import { render, staticRenderFns } from "./QuilityRxCodesUsedDrilldown.vue?vue&type=template&id=988450b0&scoped=true&"
import script from "./QuilityRxCodesUsedDrilldown.vue?vue&type=script&lang=js&"
export * from "./QuilityRxCodesUsedDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988450b0",
  null
  
)

export default component.exports